var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar",class:_vm.avatarClasses},[_c('img',{attrs:{"src":_vm.user.avatar}})])}
var staticRenderFns = []

export { render, staticRenderFns }